// apps/web/src/lib/estoque/abastecimento-url.ts — Fase 16.1, Plano 11 (D-28; UI-29).
// Parser puro do filtro de estado vindo da URL da fila de abastecimento (links do painel).
import type { EstadoSolicitacaoAbastecimento } from '@pieltec/contracts';

/** Os cinco estados do contrato; qualquer outro valor de `?estado=` é ignorado (allowlist). */
export const ESTADOS_SOLICITACAO_ABASTECIMENTO: readonly EstadoSolicitacaoAbastecimento[] = [
  'SOLICITADA',
  'PARCIALMENTE_SEPARADA',
  'SEPARADA',
  'ENTREGUE',
  'CANCELADA',
];

/** Lê `?estado=` uma vez: valor exato da lista ou '' (Todos), sem mensagem de erro para valor inválido. */
export function lerEstadoDaUrl(search: string): EstadoSolicitacaoAbastecimento | '' {
  const valor = new URLSearchParams(search).get('estado');
  return ESTADOS_SOLICITACAO_ABASTECIMENTO.find((estado) => estado === valor) ?? '';
}
